import { render, staticRenderFns } from "./CompraLeiteSpotExibicao.vue?vue&type=template&id=63cc56ce&scoped=true&"
import script from "./CompraLeiteSpotExibicao.vue?vue&type=script&lang=js&"
export * from "./CompraLeiteSpotExibicao.vue?vue&type=script&lang=js&"
import style0 from "./CompraLeiteSpotExibicao.vue?vue&type=style&index=0&id=63cc56ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc56ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
